//import kendo from '@progress/kendo-ui';
//import { isDate } from 'util';

let placeHolderMap = new WeakMap();

class Utilities {
	constructor() {
		$(document).on('change', 'input', function (e) {
			var currentInput = $(e.target);
			var errorSign = currentInput.closest('div').find('.fa-exclamation-circle.text-danger');
			if (errorSign !== undefined && errorSign.length > 0) {
				errorSign.remove();
			}
		});
		$(document).on('focus', 'textarea', function (e) {
			var currentInput = $(e.target);
			var errorSign = currentInput.closest('.row').find('label .fa-exclamation-circle.text-danger');
			if (errorSign !== undefined && errorSign.length > 0) {
				errorSign.remove();
			}
		});
	}

	IsInternetExplorer() {
		let ua = window.navigator.userAgent;
		let oldIE = ua.indexOf('MSIE ');
		let newIE = ua.indexOf('Trident/');
		return oldIE > -1 || newIE > -1;
	}

	IsEdgeBrowser() {
		return /Edge\/\d./i.test(navigator.userAgent);
	}

	LoadHtmlTemplate(path, options, callback) {
		$.get(path, {
			'partialViewPath': options.viewName,
			'tyrePosition': options.positionLabel
		}).done(function (template) {
			var $template = $(template);
			callback($template);
		});
	}

	isDate(date) {
		return date instanceof Date && !isNaN(date.valueOf());
	}

	IsInArray(date, dates) {
		for (let idx = 0, length = dates.length; idx < length; idx++) {
			let d = dates[idx];
			if (this.isDate(d)) {
				if (date.getFullYear() === d.getFullYear() &&
					date.getMonth() === d.getMonth() &&
					date.getDate() === d.getDate()) {
					return true;
				}
			}
		}
		return false;
	}

	previousDaysInCurrentMonth() {
		let today = new Date();
		let previousDays = [];
		for (let i = 0; i <= moment().daysInMonth(); i++) {
			if (i < today.getUTCDate()) {
				previousDays.push(new Date(today.getFullYear(), today.getMonth(), i));
			}
		}
		return previousDays;
	};

	IsEven(n) {
		return n % 2 === 0;
	}

	GetMonthNames() {
		return ['January', 'February', 'March', 'April', 'May', 'June',
			'July', 'August', 'September', 'October', 'November', 'December'
		];
	}

	ShowNextRow(currentDomElement, nextXrows, targetClass) {
		$(currentDomElement).parents('.' + targetClass).nextAll(':lt(' + nextXrows + ')').show();
	}

	CheckIfMobilePhoneProvided(inputList) {
		var regex = /^(\+44\s?7\d{3}|\(?07\d{3}\)?)\s?\d{3}\s?\d{3}$/;
		if (inputList !== undefined && inputList.length > 0) {
			for (var index = 0; index < inputList.length; index++) {
				var currentInput = inputList[index];
				var phoneNumber = $(currentInput).val();
				if (regex.test(phoneNumber) === true) return true;
			}
		}
		return false;
	}

	GetVisibleCount() {
		// Left-align the breadcrumbs to simplify the calculation
		var offsetWidth = $('.mobile-breadcrumb-nav')[0].offsetWidth;
		var justifyContent = $('.mobile-breadcrumb-nav').css('justify-content');

		var visibleItemCount = 0;
		$('.mobile-breadcrumb-nav').css('justify-content', 'left');
		$('.mobile-breadcrumb-nav li').each(function (index) {
			var right = $(this).position().left + $(this).outerWidth();
			if (right > offsetWidth) {
				// Exit, because our breadcrumb is not completely visible
				visibleItemCount = index;
				return false;
			}
		});
		// Restore alignment, as soon as we know how many breadcrumbs are visible
		$('.mobile-breadcrumb-nav').css('justify-content', justifyContent);
		return visibleItemCount;
	}

	FormatMobileBreadcrumbNav() {
		var serviceBreadcrumbs = $('.mobile-breadcrumb-nav li');
		serviceBreadcrumbs.show();
		var scrollWidth = $('.mobile-breadcrumb-nav')[0].scrollWidth;
		var offsetWidth = $('.mobile-breadcrumb-nav')[0].offsetWidth;
		var contentFits = scrollWidth <= offsetWidth;

		// Work out how many breadcrumbs will fit in space
		var itemCount = serviceBreadcrumbs.length;
		var visibleItemCount = 0;
		if (!contentFits) {
			// Show overflow buttons, which will reduce the size of our container, so
			// calculate visible breadcrumbs afterwards
			$('.mobile-breadcrumb-overflow').parent().show();
			visibleItemCount = this.GetVisibleCount();
		} else {
			$('.mobile-breadcrumb-nav').css('justify-content', 'center');
			$('.mobile-breadcrumb-overflow').parent().hide();
			return;
		}

		// Works out a range that positions the active breadcrumb two positions from the end
		// using a 1-based active index
		var activeIndex = serviceBreadcrumbs.index($('.mobile-breadcrumb-nav li.active')) + 1;
		var end = activeIndex + 2;
		if (end > itemCount) {
			end = itemCount;
		}
		var start;
		if (end < visibleItemCount) {
			start = 1;
			end = visibleItemCount;
		} else {
			start = end - visibleItemCount + 1;
		}
		var range = {
			active: activeIndex,
			start: start,
			end: end,
			left: start - 1,
			right: itemCount - end
		};

		// Show buttons that fall within our visible range and hide the rest
		$('.mobile-breadcrumb-nav').css('justify-content', 'space-between');

		$('#leftOverflow').text('-' + (range.left > 0 ? range.left : ''));
		$('#rightOverflow').text('+' + (range.right > 0 ? range.right : ''));

		$('.mobile-breadcrumb-nav li').each(function (index) {
			if (index + 1 < range.start || index + 1 > range.end) {
				$(this).hide();
			} else {
				$(this).show();
			}
		});
	}

	BuildMobileBreadcrumbNav() {
		var html = '';
		var template = kendo.template($('#mobile-breadcrumb-template').html());
		$("#serviceBreadcrumb li:not([style*='display: none'])").each(function (index) {
			var li = $(this);
			var heading = li.attr('data-menuanchor').toLowerCase().replace('anchor','');

			// skip confirmation step because we'll add an 'fa-check' for it after this loop
			if (heading === 'confirmation') return;

			// Evaluate CSS class
			var cssClass = '';
			if (li.hasClass('active')) {
				cssClass = 'active';
			} else if (li.hasClass('validated')) {
				cssClass = 'validated';
			}
			// Pass data to template
			var data = {
				index: index + 1,
				cssClass: cssClass,
				heading: heading
			};
			html += template(data);
		});
		html += "<li class='mobile-breadcrumb'><i class='fa fa-check'></i></li>";
		$('.mobile-breadcrumb-nav').empty().html(html);

		this.FormatMobileBreadcrumbNav();
	}

	RefreshMobileBreadcrumbNav() {
		$("#serviceBreadcrumb li:not([style*='display: none'])").each(function (index) {
			// Remove classes on our mobile breadcrumb
			var mobileBreadcrumb = $('.mobile-breadcrumb-nav li:nth-child(' + (index + 1) + ')');
			mobileBreadcrumb.removeClass('active');

			// Find out active class on main breadcrumb and set on mobile
			// breadcrumb
			var breadcrumb = $(this);
			if (breadcrumb.hasClass('active')) {
				mobileBreadcrumb.addClass('active');
			} else if (breadcrumb.hasClass('validated')) {
				mobileBreadcrumb.addClass('validated');
			}
		});
		this.FormatMobileBreadcrumbNav();
	}

	incrementBreadCrumbs(activeSection, nextSection) {
		$('[data-menuanchor="' + nextSection.anchor + '"]').addClass('active');
		$('[data-menuanchor="' + activeSection.anchor + '"]').removeClass('active').addClass('validated');
		this.RefreshMobileBreadcrumbNav();
	}

	DoNotAllowDepotSelection() {
		var subdomains = ['leaseplan', 'micheldever', 'mfs', 'northgate', 'vms', 'arval', 'omodaandjaecoo', 'mg', 'hyundai', 'honda', 'kindertons', 'byd'];
		return subdomains.includes(subdomain);
	}

	DoNotShowCalendar() {
		var hideCalendar = false;
		if (this.IsVMS()) {
			if (this.IsChecked('ServiceRequiredRapidResponse') || this.IsChecked('ServiceRequiredNextDayMobile') || this.IsChecked('ServiceRequiredSameDayMobile')) {
				hideCalendar = true;
			};
		}

		var subdomains = ['mfs'];
		return (subdomains.includes(subdomain) || hideCalendar);
	}

	IsChecked = (id) => {
		var result = false;

		if ($('#' + id).length) {
			result = $('#' + id).is(":checked");
		}

		return result;
	}

	IsMfs() {
		return subdomain == 'mfs';
	}

	IsVMS() {
		return subdomain == 'vms';
	}
}

class ValidationResponse {
	constructor(success, inputConcerned, errorMessage) {
		this.success = success;
		this.input = inputConcerned;
		this.errorMessage = errorMessage;
	}
}

export let _utilities = new Utilities();
export { ValidationResponse, placeHolderMap };
